/** The Region calendar's count line for the workshops in the displayed month
 *  or week: "All N <region> workshops · M yours highlighted". */
import type { WorkshopChip } from '../primitives';

export function regionScheduleCountLine(workshops: WorkshopChip[], regionName: string): string {
  const mine = workshops.filter((w) => w.mine).length;
  return `All ${workshops.length} ${regionName} workshops · ${mine} yours highlighted`;
}
